/**
 * @param {{ name: string, name_ar?: string | null }} service
 * @param {'en' | 'ar'} locale
 */
export function serviceDisplayName(service, locale) {
  if (locale === 'ar' && service.name_ar) {
    return service.name_ar
  }

  return service.name
}

/**
 * @param {number | string} value
 * @param {(key: string, params?: Record<string, string | number>) => string} t
 */
export function formatBookAed(value, t) {
  return t('publicBook.currency', { amount: Number(value).toFixed(0) })
}

/**
 * @param {string | null | undefined} iso
 * @param {'en' | 'ar'} locale
 */
export function formatBookWhen(iso, locale) {
  if (!iso) {
    return '—'
  }

  return new Date(iso).toLocaleString(locale === 'ar' ? 'ar-AE' : 'en-GB', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
